import { MediaFileService } from '../../data/media-file.service.ts'
import type { UUID } from '@/features/shared/data/string.types.ts'

export const deleteMediaFile = async (
  id: UUID,
  folderId: UUID
): Promise<void> => {
  await MediaFileService.deleteMediaFile(id, folderId)
}
